const BasicRevievForm = function () {
	let _this = this;
	let form = $('#review-form');
	this.id = 'contactEnquiry';
	$('.zero').val(1);
	
	this.validate = () => {
		//console.log('validating');
	};
	
	this.send = form => {
		
		let send = $.ajax({
			type: 'POST',
			url: form.attr('action') + '&rand=' + Math.random(),
			data: form.serialize()
		});
		
		send.done(response => {
			let data = $.parseJSON(response);
			// spinner.remove();
			
			form.find('.form-info').fadeIn().empty().append('<p>' + data.contents + '</p>').addClass(data.status);
			
			if (data.status === 'ok') {
				form.find("input[type='text'], input[type='email'], textarea").val('');
				
				form.find('[data-default]').each(function () {
					form.val(form.data('default'));
				});
				
			} else {
				if (data.fields !== undefined) {
					$('.form-info').fadeIn();
					for (let i = 0; i <= (data.fields).length; i++) {
						form.find(".formField" + data.fields[i]).addClass('error');
					}
				}
			}
		});
		
	};
	
	form.submit(function (e) {
		e.preventDefault();
		setTimeout(function () {
			$('input, textarea').removeClass('error').removeClass('ok');
			$('.form-info').fadeOut();
		}, 4500);
		
		_this.send(form);
	});
	
	
};

export {BasicRevievForm};


// WEBPACK FOOTER //
// ../components/basicContactForm/basicReviewForm.js